import { Button } from '@cian/ui-kit/button';
import * as React from 'react';
import { PayAndPublishContainer } from '../../../ActionButtonsDesktop/components';
import { SaveDraftContainer } from '../../../SaveDraft';
import { VisibleViolationsWarningContainer } from '../../../VisibleViolationsWarning';
import * as styles from './ActionButtonsMobile.css';

interface IActionButtonsMobileProps {
  isAuctionEnabled: boolean;
  onAuctionButtonClick(): void;
}

export const ActionButtonsMobile = ({ isAuctionEnabled, onAuctionButtonClick }: IActionButtonsMobileProps) => {
  return (
    <>
      <VisibleViolationsWarningContainer />

      <div className={styles['draft']}>
        <SaveDraftContainer />
      </div>

      <div className={styles['wrapper']}>
        {isAuctionEnabled && (
          <div className={styles['button']}>
            <Button type="button" fullWidth theme="fill_secondary" onClick={onAuctionButtonClick}>
              Опередить конкурентов
            </Button>
          </div>
        )}

        <div className={styles['button']}>
          <PayAndPublishContainer />
        </div>
      </div>
    </>
  );
};
